import React, { useEffect, useState } from 'react';
import { TickCircle, Warning2, InfoCircle, CloseCircle, CloseSquare } from 'iconsax-react';

const Toast = ({ id, message, type, duration, onClose }) => {
    const [isExiting, setIsExiting] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            handleClose();
        }, duration);

        return () => clearTimeout(timer);
    }, [duration]);

    const handleClose = () => {
        setIsExiting(true);
        setTimeout(() => {
            onClose(id);
        }, 300); // Match animation duration
    };

    const getIcon = () => {
        switch (type) {
            case 'success':
                return <TickCircle size={24} variant="Bold" className="text-white" />;
            case 'error':
                return <CloseCircle size={24} variant="Bold" className="text-error" />;
            case 'warning':
                return <Warning2 size={24} variant="Bold" className="text-warning" />;
            case 'info':
            default:
                return <InfoCircle size={24} variant="Bold" className="text-info" />;
        }
    };

    const getStyles = () => {
        const base = "flex items-start gap-3 p-4 rounded-medium shadow-card min-w-[300px] max-w-md pointer-events-auto transition-all duration-300 transform";

        switch (type) {
            case 'success':
                return `${base} bg-success border-none text-white`;
            case 'error':
                return `${base} bg-primary-white dark:bg-neutral-800 border-l-4 border-error`;
            case 'warning':
                return `${base} bg-primary-white dark:bg-neutral-800 border-l-4 border-warning`;
            case 'info':
            default:
                return `${base} bg-primary-white dark:bg-neutral-800 border-l-4 border-info`;
        }
    };

    return (
        <div
            className={`
        ${getStyles()}
        ${isExiting ? 'opacity-0 translate-x-full' : 'opacity-100 translate-x-0'}
      `}
            role="alert"
        >
            <div className="flex-shrink-0 mt-0.5">
                {getIcon()}
            </div>
            <div className="flex-1 mr-2">
                <p className={`text-body-medium font-medium break-words ${type === 'success' ? 'text-white' : 'text-neutral-800 dark:text-primary-white'}`}>
                    {message}
                </p>
            </div>
            <button
                onClick={handleClose}
                className={`flex-shrink-0 transition-colors ${type === 'success' ? 'text-white/80 hover:text-white' : 'text-neutral-400 hover:text-neutral-600 dark:hover:text-neutral-200'}`}
            >
                <CloseSquare size={20} />
            </button>
        </div>
    );
};

export default Toast;
